// extracted by mini-css-extract-plugin
export default {"badge":"badge__a54f9171","special_offer":"special_offer__a54f9171"};